import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = m/s². */
export const ACCELERATION_PIVOT: Record<string, number> = {
  'm/s2': 1,
  'in/s2': 0.0254,
  'ft/s2': 0.3048,
  'mm/s2': 0.001,
  g_n: 9.80665,
};

export const transformAcceleration = createPivotTransformer(ACCELERATION_PIVOT);
